import { Navigate, RouteObject } from "react-router-dom";
import { routerAdminPlayer } from "./players/routesAdminPlayer";
import { routerAdminTeam } from "./teams/routesAdminTeam";
import { routerAdminTournament } from "./tournaments/routesAdminTournament";
import { routerAdminReferee } from "./referees/routesAdminReferee";
import { routerAdminStadium } from "./stadium/routesAdminStadium";
import { NotFound } from "../../commons/components";
import Initialize from "./Initialize";
import { routerAdminUser } from "./users/routesAdminUser";
import Dashboard from "./dashboard/Dashboard";
import ProfileDetailManage from "../auth/profile/ProfileDetailManage";
import { routerAdminOrganizer } from "./organizers/routesAdminOrganizer";

const DASHBOARD = "dashboard";
const PLAYERS = "players";
const TEAMS = "teams";
const TOURNAMENTS = "tournaments";
const REFEREES = "referees";
const STADIUMS = "stadiums";
const ORGANIZERS = "organizers";
const USERS = "users";
const PROFILE = "me";

export const routerAdmin: RouteObject[] = [
  {
    path: "",
    element: <Navigate to={DASHBOARD} replace />,
  },
  { path: DASHBOARD, element: <Dashboard /> },
  { path: PLAYERS, children: routerAdminPlayer },
  { path: TEAMS, children: routerAdminTeam },
  { path: TOURNAMENTS, children: routerAdminTournament },
  { path: REFEREES, children: routerAdminReferee },
  { path: STADIUMS, children: routerAdminStadium },
  { path: ORGANIZERS, children: routerAdminOrganizer },
  { path: USERS, children: routerAdminUser },
  { path: PROFILE, element: <ProfileDetailManage /> },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "initialize",
    element: <Initialize />, //this is for development only
  },
];
